import React, {useEffect, useState} from "react";
import {useNavigate} from "react-router-dom";
import {apiRequest} from "../api"; // Import reusable API function
import "../css/integrations.css";

const Integrations = () => {
    const [availableIntegrations, setAvailableIntegrations] = useState([]);
    const [userIntegrations, setUserIntegrations] = useState([]);
    const navigate = useNavigate();
    const token = localStorage.getItem("token"); // Get token from localStorage

    // Fetch available integrations & user integrations
    useEffect(() => {
        const fetchIntegrations = async () => {
            try {
                const integrations = await apiRequest(`${process.env.REACT_APP_API_BASE_URL}/integrations`, "GET", null, token);
                console.log(integrations)
                setAvailableIntegrations(integrations);
            } catch (error) {
                console.error("Error fetching available integrations:", error);
            }
        };
        const mockIntegrations = [
            {id: 1, name: "Microsoft Outlook", is_active: false, image: "/outlook.png"},
        ];

        const fetchUserIntegrations = async () => {
            try {
                const userIntegrations = await apiRequest(`${process.env.REACT_APP_API_BASE_URL}/user/integrations`, "GET", null, token);
                console.log(userIntegrations)
                setUserIntegrations(userIntegrations);
            } catch (error) {
                console.error("Error fetching user integrations:", error);
            }
        };

        fetchIntegrations();
        fetchUserIntegrations();
        setAvailableIntegrations(mockIntegrations)
    }, [token]); // Depend on token to ensure valid request

    // Handle OAuth redirect
    const handleConnect = async (integration) => {
        if (integration.name === "Outlook") {
            const tenant_id = process.env.REACT_APP_MICROSOFT_TENANT_ID
            const authUrl = `https://login.microsoftonline.com/common/oauth2/v2.0/authorize`;
            const params = new URLSearchParams({
                client_id: process.env.REACT_APP_MICROSOFT_CLIENT_ID,
                response_type: "code",
                redirect_uri: process.env.REACT_APP_OAUTH_CALLBACK_URL,
                scope: "Mail.Send Mail.Read",
                state: localStorage.getItem("token"),
            });
            window.location.href = `${authUrl}?${params.toString()}`;

        }
    };

    return (
        <div className="integrations-container">

            <div className="integrations-list">
                {availableIntegrations.map((integration) => {
                    const userIntegration = userIntegrations.find(
                        (ui) => ui.id === integration.id
                    );

                    return (
                        <div key={integration.id} className="integration-card">
                            <img src="/outlook.png" alt={integration.name} className="integration-icon"/>
                            <h3>{integration.name}</h3>

                            <p className="integration-status">
                                {integration.is_active ? "1/1 email accounts connected" : "0/1 email accounts connected"}
                            </p>
                            <button
                                className={integration.is_active ? "btn btn-secondary" : "btn btn-primary"}
                                onClick={() => handleConnect(integration)}
                            >
                                {integration.is_active ? "Disconnect" : "Connect"}
                            </button>
                        </div>
                    );
                })}
            </div>
        </div>
    );
};

export default Integrations;